import gql from 'graphql-tag';

import client from '../graphqlAPI';

// One radio program or episode with everything the form edits, airings included.
const GET_RADIO_SHOW = gql`
  query getRadioShow($id: Int!) {
    getRadioShow(id: $id) {
      isAuth
      show {
        _id
        id
        parent
        parentSlug
        parentTitle { es ca en pt }
        slug
        title { es ca en pt }
        subtitle { es ca en pt }
        text { es ca en pt }
        status
        highlight
        channel
        image
        imageSquare
        mp3
        fileSize
        mixcloud
        youtube
        spotify
        isPlaylist
        duration
        lang
        appleCategory
        appleSubcategory
        tagIds
        categoryIds
        firstAirDate
        airings { id date channel }
        createdAt
        updatedAt
      }
    }
  }
`;

const getRadioShow = async ({ id }) => {
  try {
    const result = await client
      .query({
        query: GET_RADIO_SHOW,
        errorPolicy: 'all',
        variables: { id },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getRadioShow: getRadioShowData },
    } = result;

    if (getRadioShowData) {
      return getRadioShowData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getRadioShow = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getRadioShow Error: ${error}`);
    return null;
  }
};

export default getRadioShow;
